import { styled } from '@mui/system';
import LoadingButton from '@mui/lab/LoadingButton';

export const CustomButton = styled(LoadingButton)({
  backgroundColor: '#1e1e1e',
  width: '40%',  // ボタン全体の幅
  border: '1px solid #4a4a4a',
  color: '#e9e9e9', // テキストカラー
  textTransform: 'none',
  fontSize: 12,
  '&:hover': {
    backgroundColor: '#333333',  // ホバー時の背景色
  },
  '&:active': {
    backgroundColor: '#000000',  // アクティブ時の背景色
  },
  '&.Mui-disabled': {
    backgroundColor: '#4a4a4a',  // 無効状態の背景色
  }
});
